import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import PartnersCarousel from "@/components/PartnersCarousel";
import AboutSection from "@/components/AboutSection";
import HowItWorksSection from "@/components/HowItWorksSection";
import DifferentialsSection from "@/components/DifferentialsSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import ContactForm from "@/components/ContactForm";
import FAQSection from "@/components/FAQSection";
import CTASection from "@/components/CTASection";

const Index = () => {
  return (
    <main className="min-h-screen">
      <Header />
      <HeroSection />
      <AboutSection />
      <div id="how-it-works">
        <HowItWorksSection />
      </div>
      <PartnersCarousel />
      <div id="differentials">
        <DifferentialsSection />
      </div>
      <div id="testimonials">
        <TestimonialsSection />
      </div>
      <div id="contato">
        <ContactForm />
      </div>
      <div id="faq">
        <FAQSection />
      </div>
      <CTASection />
    </main>
  );
};

export default Index;
